import { authClient, getServiceURL, getURL } from '@/utils'
import Toggles from '@domain/toggles/Toggles'
import { getServiceURLserverSide } from '@infrastructure/Urls'

const generateOrder = ({ projectId, lang }) => {
	const url = `${getURL(`/v2/orders/by-project/${projectId}`, 'api')}`
	return authClient.get(url, {
		params: {
			lang
		}
	})
}

const getOrder = ({ orderId, lang }) => {
	const accessoryPriceInOrderViewToggle = Toggles.isEnabled("accessoryPriceInOrderView")
	let url = `${getServiceURL('orders')}/v1/orders/${orderId}`
	if (accessoryPriceInOrderViewToggle) {
		url = `${getURL(`/v2/orders/${orderId}`, 'api')}`
	}
	if(Toggles.isEnabled("unifiedCodeVersion")) {
		url = `${getServiceURLserverSide('v3')}/orders/${orderId}`
	}
	return authClient.get(url, {
		params: {
			lang
		}
	})
}

const processOrder = (order) => {
	const urlToFetch = getURL('/v2/orders/process/', 'api')

	return new Promise((resolve, reject) =>
		authClient
			.post(urlToFetch, order)
			.then((serviceResponse) => {
				resolve(serviceResponse)
			})
			.catch((error) => {
				if (error?.response?.status === 403) {
					resolve({
						...error,
						response: {
							...error.response,
							status: 403,
							processOrderSuccess: false,
							data: {
								status: 403
							}
						}
					})

				}
				if (error?.response?.status === 400 && error?.response?.data?.code === 'NO_CLIENT_CODE') {
					resolve({
						...error,
						response: {
							...error.response,
							status: 200,
							processOrderSuccess: false
						}
					})
				}
				reject(error)
			})
	)
}



export default {
	generateOrder,
	getOrder,
	processOrder
}
